<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  background-color: #f5f5f5;
  color: #333;
  line-height: 1.5;
}

.page-container {
  margin: 0 auto;
  background-color: #fff;
  min-height: 100vh;
  position: relative;
}
.expired-container{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
.expired-text{
  width: 100%;
  text-align: center;
}
.expired-container .expired-text .text{
  color: gray;
  margin-top: 10px;
}
</style>

<template>
  <div>
    <div class="page-container" v-if="expired">
      <div class="expired-container">
        <div class="expired-text">
          <svg t="1770692393059" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="76444" width="68" height="68"><path d="M174.128762 136.874667 969.142857 136.874667l0 787.748571c0 41.423238-35.59619 74.99581-79.530667 74.99581L174.128762 999.619048c-43.934476 0-79.506286-33.572571-79.506286-74.99581l19.846095 0c32.938667 0 59.63581-25.234286 59.63581-56.32s-26.697143-56.271238-59.63581-56.271238L94.622476 812.032 94.622476 774.582857l19.846095 0c32.938667 0 59.63581-25.185524 59.63581-56.271238s-26.697143-56.32-59.63581-56.32L94.622476 661.991619l0-37.497905 19.846095 0c32.938667 0 59.63581-25.161143 59.63581-56.271238C174.128762 537.185524 147.407238 512 114.468571 512L94.622476 512l0-37.497905 19.846095 0c32.938667 0 59.63581-25.185524 59.63581-56.246857 0-31.134476-26.697143-56.32-59.63581-56.32L94.622476 361.935238l0-37.497905 19.846095 0c32.938667 0 59.63581-25.185524 59.63581-56.246857S147.407238 211.943619 114.468571 211.943619L94.622476 211.943619 94.622476 99.376762C94.622476 57.953524 130.194286 24.380952 174.128762 24.380952l715.50781 0c29.403429 0 54.710857 15.189333 68.461714 37.497905L174.128762 61.878857c-21.967238 0-39.765333 16.774095-39.765333 37.497905S152.137143 136.874667 174.128762 136.874667zM533.77219 660.382476c120.271238 0 217.721905-94.939429 217.721905-212.016762s-97.450667-211.968-217.721905-211.968c-120.222476 0-217.697524 94.890667-217.697524 211.968S413.549714 660.382476 533.77219 660.382476zM447.24419 466.944c15.286857-14.872381 36.961524-19.772952 56.441905-14.652952l-35.523048 34.57219c-0.097524 0.048762-0.219429 0.121905-0.316952 0.24381l-41.276952 40.228571c-11.361524 11.068952-11.361524 29.110857 0 40.155429 11.434667 11.142095 29.891048 11.142095 41.276952 0l41.276952-40.155429c0.292571-0.292571 0.487619-0.658286 0.78019-0.950857l34.937905-33.938286c5.193143 18.992762 0.24381 40.057905-15.09181 55.003429l-41.276952 40.228571c-22.77181 22.186667-59.733333 22.186667-82.529524 0-22.79619-22.25981-22.79619-58.270476 0-80.530286L447.24419 466.944zM498.44419 518.485333l-0.048762-0.048762c-2.681905 2.608762-6.436571 4.291048-10.581333 4.291048-8.192 0-14.823619-6.436571-14.823619-14.409143 0-4.169143 1.877333-7.92381 4.803048-10.532571l98.03581-95.427048c2.755048-2.80381 6.582857-4.632381 10.849524-4.632381 8.192 0 14.799238 6.485333 14.799238 14.457905 0 3.925333-1.609143 7.509333-4.291048 10.118095l0.048762 0L498.44419 518.485333zM606.281143 432.956952l41.22819-40.228571c11.385905-11.142095 11.385905-29.110857 0-40.228571-11.361524-11.142095-29.817905-11.142095-41.22819 0l-41.301333 40.228571 0 0 0 0-35.718095 34.694095c-5.12-18.919619-0.121905-39.936 15.11619-54.832762l41.22819-40.228571c22.820571-22.211048 59.757714-22.211048 82.578286 0s22.820571 58.270476 0 80.481524l-41.301333 40.228571c-15.311238 14.994286-37.034667 19.821714-56.58819 14.652952l34.450286-33.52381C605.208381 433.785905 605.817905 433.42019 606.281143 432.956952zM134.363429 268.190476c0 10.361905-8.899048 18.748952-19.870476 18.748952l-39.740952 0c-10.971429 0-19.870476-8.387048-19.870476-18.748952s8.899048-18.748952 19.870476-18.748952l39.740952 0C125.464381 249.441524 134.363429 257.828571 134.363429 268.190476zM74.727619 399.433143l39.740952 0c10.971429 0 19.870476 8.387048 19.870476 18.797714 0 10.288762-8.899048 18.748952-19.870476 18.748952l-39.740952 0c-10.971429 0-19.870476-8.46019-19.870476-18.748952C54.857143 407.844571 63.75619 399.433143 74.727619 399.433143zM74.727619 549.497905l39.740952 0c10.971429 0 19.870476 8.411429 19.870476 18.748952 0 10.386286-8.899048 18.773333-19.870476 18.773333l-39.740952 0c-10.971429 0-19.870476-8.387048-19.870476-18.773333C54.857143 557.909333 63.75619 549.497905 74.727619 549.497905zM74.727619 699.562667l39.740952 0c10.971429 0 19.870476 8.387048 19.870476 18.748952S125.464381 737.03619 114.468571 737.03619l-39.740952 0c-10.971429 0-19.870476-8.387048-19.870476-18.748952S63.75619 699.562667 74.727619 699.562667zM74.727619 849.578667l39.740952 0c10.971429 0 19.870476 8.387048 19.870476 18.748952s-8.899048 18.748952-19.870476 18.748952l-39.740952 0c-10.971429 0-19.870476-8.387048-19.870476-18.748952S63.75619 849.578667 74.727619 849.578667z" p-id="76445" fill="#59c0f6"></path></svg>
          <div class="text">您的预约已失效</div>
        </div>
      </div>
    </div>
    <template v-else>
      <visitor-reservation-info v-if="visitorInfo.confirmStatus == 1" :visitor-info="visitorInfo" @refresh="getShareInfo"/>
      <visitor-confirm  v-else :visitor-info="visitorInfo" @refresh="getShareInfo"></visitor-confirm>
    </template>
  </div>
</template>


<script>
import { VisitorApplyApi } from '@/api/server/visitorApply';
import VisitorConfirm from "@/views/visitor/share/components/visitor_confirm.vue";
import VisitorReservationInfo from "@/views/visitor/share/components/visitor_reservation_info.vue";
export default {
  components: {
    VisitorConfirm,
    VisitorReservationInfo
  },
  data() {
    return {
      expired: false,
      visitorInfo: {
        name: '',
        phone: '',
        appointmentTime: '',
        duration: ''
      },
      shareCode: ''
    }
  },
  mounted() {
    let params = this.$route.params;
    this.shareCode = params?.id;
    if(params?.id){
      this.getShareInfo(params.id);
    }else{
      this.expired = true;
    }
  },
  methods: {
    getShareInfo() {
      if(this.shareCode){
        VisitorApplyApi.getShareInfo(this.shareCode).then(response => {
          if(response.code == 200 && response.data){
            this.visitorInfo = response.data;
          }else{
            this.expired = true;
          }
        })
      }
    }
  }
};
</script>